import { PatientDocumentRepository as IPatientDocumentRepository } from 'repository/interfaces/patient-document-repository'
import { IApiRepository } from 'service/protocols/api/api-repository'
import { ApiStatusCode } from 'service/protocols/api/api-client'
import { CustomError } from 'common/errors'
import { GetPatientDocuments } from 'domain/usecases/patient/get-patient-documents'

export class PatientDocumentRepository implements IPatientDocumentRepository {
  constructor(private readonly apiRepository: IApiRepository) {}

  async getPatientDocuments(
    params: GetPatientDocuments.Params
  ): Promise<GetPatientDocuments.Model> {
    const apiRepository = this
      .apiRepository as IApiRepository<GetPatientDocuments.Model>

    const httpResponse: any = await apiRepository.get({
      url: `/document/search`,
      params: params
    })

    if (
      !httpResponse.statusCode ||
      (httpResponse.statusCode && httpResponse.statusCode !== ApiStatusCode.ok)
    ) {
      throw new CustomError('Ocorreu um erro ao buscar documentos do paciente')
    } else {
      return httpResponse.body as GetPatientDocuments.Model
    }
  }
}
